module.exports = __webpack_public_path__ + "media/flat/default-7c05ae19.svg";